<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="!hideLibrary" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="!isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <LibraryItems rightPanelId="sidebar-new-unit" organizationScopedState="organizationUnit" libraryScopedState="unit" />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("unit.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('unit.enter-name')"
            :label="$t('unit.name')"
          />

          <h6 class="mt-4">{{ $t("unit.parent") }}</h6>
          <filter-select
            id="parentFilter"
            ref="parentFilter"
            :placeholder="$t('unit.select-parent')"
            :multiple="false"
            @filter="onSearch"
            :selected="form.parent"
            @changed="onSelect"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="isEditMode">{{ form.name }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("unit.new") }}</span>
        </h2>

        <sweet-input
          v-model="form.name"
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          type="text"
          layout="vertical"
          :placeholder="$t('common.name')"
          :label="$t('unit.name')"
        />

        <h6 class="mt-4">{{ $t("unit.parent") }}</h6>

        <i class="fas fa-info-circle"></i> {{ $t("unit.create-info") }}

        <filter-select
          id="parentFilter"
          ref="parentFilter"
          :placeholder="$t('unit.select-parent')"
          :multiple="false"
          @filter="onSearch"
          :customLabel="customLabel"
          :selected="form.parent"
          @changed="onSelect"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
  },
  data() {
    return {
      form: { name: undefined, parent: undefined },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationUnit/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationUnit/editedEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationUnit/isEditMode"];
    },
  },
  mounted() {},
  methods: {
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationUnit/save", this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationUnit/paginateForSelect`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onSelect(item) {
      this.form = { ...this.form, parent: item };
    },
  },
};
</script>
